import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import { AppWrap } from '../../wrapper';
import Typical from 'react-typical';

import './Header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <div className='app__header app__flex'>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className='app__header-info'
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span> 👋 </span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text"> Hello, I am</p>
              <h1 className="head-text">Ashwani</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <h3>
              {" "}
              <Typical
                loop={Infinity}
                steps={[
                  "GATE ~ (AIR 1597)",
                  1000,
                  "Android Developer",
                  1000,
                  "Web Developer",
                  1000,
                  "Blockchain",
                  1000,
                  "ReactJS",
                  1000,
                  "Flutter",
                  1000,
                  "MERN",
                  1000,
                  "C++",
                  1000,
                ]}
              />
            </h3>
            {/* <p className="p-text">Web Developer</p>
            <p className="p-text">App Developer</p> */}
          </div>
        </div>

      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__header-img'
      >
        <img src={images.ashwani} alt="profile_bg" />
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: 'easeInOut' }}
          className='overlay_circle'
          src={images.circle}
          alt="profile_circle"
        />
      </motion.div>

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'
      >
        {[images.flutter, images.redux, images.sass].map((circle, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>

    </div>
  )
}

export default AppWrap(Header, 'home');